var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTextWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25.018,
    viewBox: "0 0 25 25.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.162,5.548a2.055,2.055,0,0,0-2.8.751L19.538,9.453V6.841a.489.489,0,0,0-.977,0v4.3l-5.367,9.3a.484.484,0,0,0-.063.192l-.367,3.408H1.165V.977h17.4V2.443a.489.489,0,0,0,.977,0V.489A.489.489,0,0,0,19.05,0H.677A.489.489,0,0,0,.188.489V24.53a.489.489,0,0,0,.489.489H19.05a.489.489,0,0,0,.489-.489V17.662l5.376-9.311a2.055,2.055,0,0,0-.752-2.8ZM14.023,21.484l1.409.813-1.624,1.186Zm4.538,2.558H14.7l1.914-1.4a.5.5,0,0,0,.135-.15l1.812-3.138Zm-2.414-2.46-1.862-1.075L21.437,8.119,23.3,9.194Zm7.92-13.719-.28.485L21.926,7.272l.28-.485a1.075,1.075,0,1,1,1.862,1.075Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M376.677,85a.489.489,0,1,0,.345.143A.491.491,0,0,0,376.677,85Z",
    transform: "translate(-357.627 -80.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M97.547,106H87.677a.489.489,0,1,0,0,.977h9.871a.489.489,0,1,0,0-.977Z",
    transform: "translate(-82.749 -100.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M97.547,162H87.677a.489.489,0,0,0,0,.977h9.871a.489.489,0,0,0,0-.977Z",
    transform: "translate(-82.749 -154.084)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M219.055,218h-3.628a.489.489,0,1,0,0,.977h3.628a.489.489,0,0,0,0-.977Z",
    transform: "translate(-204.256 -207.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M98.036,274.489a.489.489,0,0,0-.489-.489H87.677a.489.489,0,0,0,0,.977h9.871A.489.489,0,0,0,98.036,274.489Z",
    transform: "translate(-82.749 -260.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M187.719,330.489a.489.489,0,0,0-.489-.489h-3.054a.489.489,0,1,0,0,.977h3.054A.489.489,0,0,0,187.719,330.489Z",
    transform: "translate(-174.533 -313.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.677,386.977h4.3a.489.489,0,1,0,0-.977h-4.3a.489.489,0,1,0,0,.977Z",
    transform: "translate(-82.749 -367.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.677,218.977h3.257a.489.489,0,0,0,0-.977H87.677a.489.489,0,1,0,0,.977Z",
    transform: "translate(-82.749 -207.348)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.677,330.977h2.516a.489.489,0,1,0,0-.977H87.677a.489.489,0,1,0,0,.977Z",
    transform: "translate(-82.749 -313.875)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTextWhite);
export default __webpack_public_path__ + "static/media/iconTextWhite.a85f1fd690bf7150b5b08de32312b52c.svg";
export { ForwardRef as ReactComponent };